var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dark":"","dense":"","item-text":"locationName","item-value":"locationId","items":_vm.locations,"value":_vm.locationId},on:{"change":_vm.setLocation}})}
var staticRenderFns = []

export { render, staticRenderFns }